export const recent_channel_action = "recent_channel_action/change";


export const recentChannelChange = (data, callback=null) => ({
    type: recent_channel_action,
    payload: {
        data,
        callback
    }
});


// WEBPACK FOOTER //
// ./src/libs/redux/actions/recent.channel.js